module.exports = __webpack_public_path__ + "Icon_VR RTZ@2x.png?a2acfc0b3164ab0ce798fb58b74b55b6";